<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h2 class="card-title ml-10">개인정보 수정</h2>
        <div class="ml-10 mb-50 row mr-10">
          <div class="col-lg-6 pl-0">
            <h4
              class="fl col-lg-2 col-sm-3 col-4 ttl-label mb-20 jipvio-text-center"
            >
              회원구분
            </h4>
            <el-radio-group
              v-model="memberGubun"
              class="col-lg-10 col-sm-9 mb-20"
            >
              <el-radio label="normal" :disabled="kakao || naver"
                >일반</el-radio
              >
              <el-radio label="kakao" :disabled="normal || naver"
                >카카오톡</el-radio
              >
              <el-radio label="naver" :disabled="normal || kakao"
                >네이버</el-radio
              >
            </el-radio-group>
          </div>
          <div class="col-lg-6 pl-0">
            <h4
              class="fl col-lg-2 col-sm-3 col-4 ttl-label mb-20 jipvio-text-center"
            >
              회원종류
            </h4>
            <el-radio-group
              v-model="memberType"
              class="col-lg-10 col-sm-9 mb-20"
            >
              <el-radio label="LE" :disabled="AG || LO">임대인</el-radio>
              <el-radio label="AG" :disabled="LE || LO">공인중개사</el-radio>
              <el-radio label="LO" :disabled="LE || AG">일반</el-radio>
            </el-radio-group>
          </div>
          <!-- 성명 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">성명</label>
            <div class="fl col-md-8 mb-10 px-0">
              <el-input class="fl" disabled v-model="UserName"> </el-input>
            </div>
          </div>

          <!-- 휴대전화 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">휴대전화</label>
            <div class="fl col-md-10 px-0">
              <el-input
                class="fl"
                style="width:80%"
                disabled
                v-model="phoneNum"
              ></el-input>
              <el-button class="fl" style="width:20%">인증</el-button>
            </div>
          </div>

          <!-- 성별 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">성별</label>
            <div class="fl col-md-8 mb-10 px-0">
              <el-input class="fl" disabled v-model="gender"> </el-input>
            </div>
          </div>

          <!-- 생년월일 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">생년월일</label>
            <div class="fl col-md-8 mb-10 px-0">
              <el-input class="fl" disabled v-model="birthDate"> </el-input>
            </div>
          </div>

          <!-- 이메일 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">이메일</label>
            <div class="fl col-md-8 mb-10 px-0">
              <el-input class="fl" disabled v-model="UserEmail" type="email">
              </el-input>
            </div>
          </div>

          <!-- 수신용 이메일 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">수신용이메일</label>
            <div class="fl col-md-8 mb-10 px-0">
              <el-input class="fl" v-model="notiEmail" type="email"> </el-input>
            </div>
          </div>

          <!-- 비밀번호 -->
          <div class="fl col-lg-6 px-0 mb-10">
            <label class="fl col-sm-2 col-form-label px-0">비밀번호</label>
            <div class="fl col-md-10 px-0">
              <el-input
                class="fl"
                style="width:80%"
                v-model="pw"
                type="password"
              ></el-input>
              <el-button @click="isModalView()" class="fl" style="width:20%"
                >변경</el-button
              >
            </div>
          </div>
        </div>
        <!-- 수정 버튼 -->
        <el-button class="m-auto" style="display:block;">수정</el-button>

        <!-- 비밀번호 변경 파업창 -->
        <ValidationObserver ref="modal">
          <card class="col-lg-4 col-md-5 modalPW" v-show="ModalView">
            <div class="card-title jipvio-text-center">
              <h2 class="mb-10">비밀번호 변경</h2>
              <span>안전한 정보보호를 위해<br />비밀번호를 변경해주세요</span>
            </div>
            <ValidationProvider
              vid="ValidateCurrentPW"
              rules="required|min:8|max:15"
              v-slot="{ failed }"
            >
              <fg-input
                class="mb-40"
                type="password"
                :error="failed ? '현재 비밀번호를 입력해주세요' : null"
                placeholder="현재 비밀번호"
                v-model="currentPW"
              >
              </fg-input>
            </ValidationProvider>

            <ValidationProvider
              vid="ValidateNewPW"
              rules="required|min:8|max:15"
              v-slot="{ failed }"
            >
              <!-- <el-input type="password" class="mb-10" placeholder="새 비밀번호" v-model="newPW"></el-input> -->
              <fg-input
                class="mb-10"
                type="password"
                :error="
                  failed
                    ? '특수문자 상관없이 8자이상 15자이하로 입력해주세요'
                    : null
                "
                placeholder="새로운 비밀번호"
                v-model="newPW"
              >
              </fg-input>
            </ValidationProvider>

            <ValidationProvider
              vid="ValidateConfirmNewPW"
              rules="required|min:8|max:15|confirmed:ValidateNewPW"
              v-slot="{ failed }"
            >
              <!-- <el-input type="password" class="mb-20" placeholder="새 비밀번호 확인" v-model="confirmNewPW"></el-input> -->
              <fg-input
                class="mb-20"
                type="password"
                :error="
                  failed ? '새로운 비밀번호와 똑같이 입력해 주세요.' : null
                "
                placeholder="새로운 비밀번호 확인"
                v-model="confirmNewPW"
              >
              </fg-input>
            </ValidationProvider>
            <div class="jipvio-text-center">
              <el-button @click="modalValidate()">수정</el-button>
              <el-button @click="isModalView()" type="info">취소</el-button>
            </div>
          </card>
        </ValidationObserver>
      </card>
    </div>
  </div>
</template>

<script>
import card from "@/components/Cards/Card.vue";
import { extend } from "vee-validate";
import { required, max, min, confirmed } from "vee-validate/dist/rules";
import { createNamespacedHelpers } from "vuex";
import userApi from "@/service/user";

extend("required", required);
extend("confirmed", confirmed);
extend("max", max);
extend("min", min);

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

import {
  Select,
  Option,
  Input,
  Button,
  Radio,
  RadioGroup,
  Popover,
  Checkbox,
  CheckboxGroup,
  Autocomplete,
  Message
} from "element-ui";
export default {
  components: {
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popover.name]: Popover,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Autocomplete.name]: Autocomplete
  },
  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    }),

    /* 회원 가입 이메일 구분 */
    emailGubun() {
      let email = this.sessionUserInfo.email.split("@");
      let emailType = email[1].split(".");
      if (emailType[0] == "naver") {
        this.naver = true;
        return "naver";
      } else if (emailType[0] == "kakao") {
        this.kakao = true;
        return "kakao";
      } else {
        this.normal = true;
        return "normal";
      }
    },

    UserGubun() {
      let type = this.sessionUserInfo.type;
      console.log("=============type");
      console.log(type);
      if (type == "LE") {
        this.LE = true;
      } else if (type == "AG") {
        this.AG = true;
      } else {
        this.LO = true;
      }
      return type;
    }
  },
  data() {
    return {
      memberGubun: "", // 회원 구분
      normal: false,
      kakao: false,
      naver: false,

      memberType: "", // 회원 종류
      LO: false,
      LE: false,
      AG: false,

      UserName: "", // 유저 이름
      phoneNum: "", //휴대전화
      gender: "", //성별
      birthDate: "", // 생년월일
      UserEmail: "", // 이메일(아이디)
      notiEmail: "", // 수신용 이메일
      pw: "", // 비밀번호
      currentPW: "", // 현재 비밀번호
      newPW: "", // 변경 비밀번호
      confirmNewPW: "", // 변경 비밀번호 확인

      ModalView: false,
      isEtv: false,

      signupUserInfo: {
        //공통
        type: null,
        authProviderId: null,
        uid: null,
        email: null,
        password: null,
        name: null,
        EmForNotice: null, //수신용 이메일

        //공인중개사
        officeName: null, //중개사무소 상호명
        officeRegNum: null, //중개사무소 등록번호
        ceoName: null, // 대표자명,
        upldId: null, // 중개사 등록증 파일 id,
        termAgreeYn: null // 개인정보 동의 여부
      }
    };
  },

  created() {
    this.bringData();
  },

  mounted() {},

  methods: {
    bringData() {
      console.log(this.sessionUserInfo);
      this.memberType = this.UserGubun;
      this.memberGubun = this.emailGubun;
      this.UserName = this.sessionUserInfo.name;
      this.phoneNum = this.sessionUserInfo.phoneNo;
      this.gender = this.sessionUserInfo.gender;
      this.birthDate = this.sessionUserInfo.birthDt;
      this.UserEmail = this.sessionUserInfo.email;
      this.notiEmail = this.sessionUserInfo.notiEmail;
      this.pw = this.sessionUserInfo.password;
    },

    isModalView() {
      this.ModalView = !this.ModalView;
    },

    setError() {
      const modal = this.$refs.modal;
      const errors = Object.entries(modal.errors)
        .map(([key, value]) => ({ key, value }))
        .filter(error => error["value"].length);

      for (let i = 0; i < errors.length; i++) {
        console.log(errors[i].key);
        if (errors[i].key == "ValidateCurrentPW") {
          modal.setErrors({
            ValidateCurrentPW: ["현재 비밀번호를 다시 확인해주세요."]
          });
        } else if (errors[i].key == "ValidateNewPW") {
          modal.setErrors({
            ValidateNewPW: ["새로운 비밀번호 조건의 맞게 입력해주세요."]
          });
        } else if (errors[i].key == "ValidateConfirmNewPW") {
          modal.setErrors({
            ValidateConfirmNewPW: ["새로운 비밀번호와 똑같이 입력해 주세요."]
          });
        }
      }
    },

    modalValidate() {
      return this.$refs.modal.validate().then(async isValid => {
        this.setError();
        if (!isValid) {
          console.log(this.$refs.modal);
          setTimeout(() => {
            // 에러가 발생한 부분만 Array로 만들기
            const errors = Object.entries(this.$refs.modal.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error["value"].length);

            Message({
              // message: this.showMessage(errors[i]["key"]),
              message: errors[0].value[0],
              type: "error",
              offset: 1 * 35
            });
          }, 100);
          return;
        }
        this.extraValidate();
        if (this.isEtv) {
          return;
        } else {
          this.isModalView();
          this.pw = this.newPW;
        }
        return isValid;
      });
    },
    //=================================================================

    extraValidate() {
      this.isEtv = false;
      let errMsg = [];

      if (this.pw !== this.currentPW) {
        errMsg.push({
          message: "현재 비밀번호를 정확히 입력해 주세요."
        });
      }
      if (this.newPW !== this.confirmNewPW) {
        errMsg.push({
          message: "비밀번호 확인을 새로운 비밀번호와 똑같이 입력해주세요"
        });
      }

      if (errMsg.length > 0) {
        this.isEtv = true;
        for (let i = 0; i < errMsg.length; i++) {
          Message({
            message: errMsg[i]["message"],
            type: "error",
            offset: (i + 1) * 35
          });
        }
        // document.getElementById(errMsg[0].focusId).focus();
      }
    }
  }
};
</script>

<style>
.jipvio-dashboard .card.modalPW {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
div.jipvio-dashboard .el-radio-group {
  font-size: 14px;
  padding-top: 10px;
}
.jipvio-dashboard .card div label {
  font-size: 1em;
}
</style>
